var XMLNode = require("../xml/XMLNode");

/**
 * This Class represents a background fill of cells within the Office
 * Open Spreadsheet document. The Fill accepts a configuration object
 * which might have either an "color" or an "type" property.
 *
 * @param {Object} oData - Configuration object for this Fill
 * @param {string} [oData.color] - HEX string defining the colored fill
 * @param {string} [oData.type] - Color independent fill type
 * @constructor
 */
function Fill(oData) {
	XMLNode.call(this, Fill.metadata);

	if (oData) {
		if (oData.color) {
			this.setFill(oData.color);
		} else if (oData.type) {
			this.setType(oData.type);
		}
	}
}

Fill.prototype = Object.create(XMLNode.prototype);
Fill.prototype.constructor = Fill;

Fill.DEFAULT_TYPE = "none";

Fill.metadata = {
	tag: "fill",
	properties: [
		{
			id: "fill",
			tag: "patternFill",
			attributes: [
				{
					id: "type",
					name: "patternType",
					value: Fill.DEFAULT_TYPE
				}
			]
		}
	]
};

/**
 * Checks if the current Fill is equal to the one that was provided.
 *
 * @param {Fill} oFill - The Fill that gets compared to the current Fill
 * @returns {boolean} - Returns true if the compared objects are of the same type and contain the same color fill
 */
Fill.prototype.equals = function(oFill) {
	if (!(oFill instanceof Fill)) {
		return false;
	}

	return this.getType() === oFill.getType()
		&& this.getFill() === oFill.getFill();
};

/**
 * Returns the color of the current Fill.
 *
 * @returns {string|null} - String containing the color HEX color of the Fill or null of no color is assigned
 */
Fill.prototype.getFill = function() {

	/* The opacity needs to be removed before returning the HEX color */
	return this.fill.childs.length ? this.fill.color.rgb.value.substring(2) : null;
};

Fill.prototype.setFill = function(sColor) {
	this.reset();

	if (sColor && typeof sColor === "string" && /^[A-Fa-f0-9]{6}$/.test(sColor)) {
		this.fill.type.value = "solid";

		/**
		 * Apply the provided color as forground color of the
		 * background. We add "FF" in front of the HEX-color
		 * for opacity.
		 */
		this.fill.addChild({
			id: "color",
			tag: "fgColor",
			attributes: [
				{
					id: "rgb",
					name: "rgb",
					value: "FF" + sColor
				}
			]
		});

		/**
		 * Add default background layer which will be used once the
		 * foreground color uses transparency
		 */
		this.fill.addChild({
			tag: "bgColor",
			attributes: [
				{
					name: "indexed",
					value: "64"
				}
			]
		});
	}
};

/**
 * Returns the current Fill type.
 *
 * @returns {string} - Current Fill type
 */
Fill.prototype.getType = function() {
	return this.fill.type.value;
};

/**
 * Assigns the given type as Fill type. The Fill will be reset to
 * default before the type is applied.
 *
 * @param {string} sType - Type that needs to be assigned
 */
Fill.prototype.setType = function(sType) {
	this.reset();

	this.fill.type.value = sType;
};

/**
 * Resets the current fill to avoid side effects that might occur
 * when the fill is modified.
 */
Fill.prototype.reset = function() {
	this.fill.type.value = "none";
	this.fill.childs.length = 0;
};

module.exports = Fill;